var map = {
	"./CoverLetter_Wilson_Easton_Huffman.pdf": 19,
	"./cyan.JPG": 20,
	"./green.JPG": 21,
	"./matte.jpg": 22,
	"./matte2.jpg": 23,
	"./orange.JPG": 24,
	"./purple.JPG": 25,
	"./red.JPG": 26,
	"./yellow.JPG": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;